"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextareaFieldLogic = void 0;
const types_1 = require("@smartsuite/types");
const clipboard_1 = require("../../utils/clipboard");
const comparisons_1 = require("../../comparisons/comparisons");
const migration_1 = require("../../utils/migration");
const text_1 = require("../../utils/text");
const intl_1 = require("../../locale/intl");
const texts_1 = require("../../texts");
const base_text_fieldtype_1 = require("../base-fields/base-text.fieldtype");
const text_field_validators_1 = require("../text-field/text-field.validators");
const validation_1 = require("../../validation/validation");
class TextareaFieldLogic extends base_text_fieldtype_1.BaseTextFieldLogic {
    constructor() {
        super(...arguments);
        this.name = "textareafield";
        this.label = (0, intl_1.$t)(texts_1.textAreaText.textarea);
        this.icon = "textarea";
        this.iconColor = "#FF9210";
        this.placeholder = (0, intl_1.$t)(texts_1.textAreaText.type_something_here);
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.textAreaText.string),
            (0, intl_1.$t)(texts_1.textAreaText.document),
            (0, intl_1.$t)(texts_1.textAreaText.paragraph),
        ];
        this.singleExportEligible = true;
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is: comparisons_1.is,
            is_not: comparisons_1.isNot,
            is_empty: comparisons_1.isEmpty,
            is_not_empty: comparisons_1.isNotEmpty,
            contains: comparisons_1.contains,
            not_contains: comparisons_1.notContains,
        };
        this.lookupMode = "lookup";
        // @ts-expect-error: Need to resolve
        this.clipboardPasteRules = clipboard_1.textPasteRules;
        // @ts-expect-error: Need to resolve
        this.migrationRules = {
            textfield: (0, migration_1.clipboardToMigrate)(clipboard_1.clipboardAnyToText),
            textareafield: (0, migration_1.clipboardToMigrate)(clipboard_1.clipboardAnyToText),
            richtextareafield: (0, migration_1.clipboardToMigrate)(clipboard_1.textToDoc),
        };
    }
    get validators() {
        const uniqueValidator = (0, validation_1.uniqueRecordFieldValueWithContext)({
            checkUniqueness: this.appRecordsService.checkUniqueness.bind(this.appRecordsService),
        });
        return { required: validation_1.required, max_length: text_field_validators_1.maxLength, unique: uniqueValidator };
    }
    getViewControlRules(field) {
        return {
            ...super.getViewControlRules(field),
            fieldInGroup: "disable",
        };
    }
    getEmptyValue() {
        return "";
    }
    getInitialFieldValue(startValue) {
        return startValue || "";
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            saveKeys: ["Tab"],
            deleteValueOnFirstKeypress: false,
            editorWidth: "250px",
        };
    }
    formatActivityRecordChangeValues(previousValue, currentValue) {
        const showOnlyChangedSentences = !!(currentValue && previousValue);
        return {
            previousValue: "",
            currentValue: (0, text_1.getTextDifference)(previousValue, currentValue, showOnlyChangedSentences),
        };
    }
    getGridColumnSettings(field) {
        return {
            ...super.getGridColumnSettings(field),
            headerAlignment: "left",
        };
    }
    groupByKey() {
        return "";
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 170,
            minWidth: 90,
        };
    }
    filterToRecordValue(filterValue, comparison, field) {
        if (comparison === "is" && filterValue) {
            return filterValue;
        }
        throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
    }
    prepareValueForClipboard(value, field, userPreferences) {
        const text = this.valueToString(value, field, userPreferences);
        return { text: (0, text_1.removeNewLinesAndExcessSpaces)(text), rawValue: value };
    }
    isSupportedByBulkAction() {
        return false;
    }
}
exports.TextareaFieldLogic = TextareaFieldLogic;
